import { memo } from 'react'
import { Minus } from '@/assets/icons/Minus.tsx'
import { Plus } from '@/assets/icons/Plus.tsx'

type Props = React.PropsWithoutRef<{
  zoomIn: VoidFunction
  zoomOut: VoidFunction
}>

export const ZoomButtons = memo(
  function ZoomButtons(props: Props) {
    return (
      <div className="flex items-center gap-2">
        <button
          className="flex size-10 select-none items-center justify-center rounded-sm border bg-white text-primary transition-colors duration-200 hover:border-gray-300"
          onClick={props.zoomOut}
          type="button"
        >
          <Minus className="size-5" />
        </button>

        <button
          className="flex size-10 select-none items-center justify-center rounded-sm border bg-white text-primary transition-colors duration-200 hover:border-gray-300"
          onClick={props.zoomIn}
          type="button"
        >
          <Plus className="size-5" />
        </button>
      </div>
    )
  },
  () => true
)
